import { FC } from "react";

import { useMapColorsService } from "./use-map-colors-service";

export const MapColorsService: FC = () => {
  useMapColorsService();
  return null;
};
